import { render, staticRenderFns } from "./noticeStyle.vue?vue&type=template&id=f3f0b4e4&scoped=true"
import script from "./noticeStyle.vue?vue&type=script&lang=js"
export * from "./noticeStyle.vue?vue&type=script&lang=js"
import style0 from "./noticeStyle.vue?vue&type=style&index=0&id=f3f0b4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f0b4e4",
  null
  
)

export default component.exports